import React, { useLayoutEffect, useRef, useState } from "react";
import { useI18n } from "@/contexts/I18nContext";

/** Long-form text clamped to `lines`, with a toggle only when it actually overflows. */
export const ReadMore = ({ text, lines = 6, className = "", testid }) => {
  const { t } = useI18n();
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el && !open) setOverflows(el.scrollHeight > el.clientHeight + 2);
  }, [text, open]);

  if (!text) return null;
  return (
    <div className={className}>
      <p
        ref={ref} data-testid={testid}
        className="reading whitespace-pre-line text-foreground/90"
        style={open ? undefined : { display: "-webkit-box", WebkitLineClamp: lines, WebkitBoxOrient: "vertical", overflow: "hidden" }}
      >
        {text}
      </p>
      {(overflows || open) && (
        <button onClick={() => setOpen((o) => !o)} aria-expanded={open}
          className="mt-2 text-primary underline-offset-4 hover:underline">
          {open ? t("read_less") : t("read_more")}
        </button>
      )}
    </div>
  );
};
